import { render, staticRenderFns } from "./ModuleTextWithImages.vue?vue&type=template&id=be130ff8&scoped=true&"
import script from "./ModuleTextWithImages.vue?vue&type=script&lang=js&"
export * from "./ModuleTextWithImages.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTextWithImages.vue?vue&type=style&index=0&id=be130ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be130ff8",
  null
  
)

export default component.exports